<template lang="pug">
.main
  Loading(
      v-if="getLoading"
  )
  Navbar(
    v-if="showNavbar"
    )
  .main__content(
    :class="{ 'main__content--flush': isFlush }"
  )
    RouterView(
      name="content"
    )
</template>

<script>

import {
  mapActions,
  mapGetters
} from 'vuex'

import {
  Navbar,
  Loading
} from '@/components/atoms'

export default {
  data: () => ({
    showNavbar: true
  }),
  created () {
    this.setInitialiseStore()
    this.$store.dispatch('events/setEvents')
  },
  mounted () {
    this.updateNavbar()
  },
  updated () {
    this.updateNavbar()
  },
  computed: {
    ...mapGetters('main', [
      'getLoading'
    ]),
    isFlush () {
      // Todas as telas usam hero full-bleed que encosta na navbar (ou ocupam a
      // viewport inteira, como as de autenticação). Por isso o padrão é FLUSH
      // (sem padding no container) — telas novas já nascem certas, sem faixas
      // brancas nas bordas. Se algum dia uma tela precisar do respiro no topo,
      // liste o nome da rota em PADDED.
      const PADDED = []
      return !PADDED.includes(this.$route.name)
    }
  },
  methods: {
    ...mapActions('users', [
      'setInitialiseStore'
    ]),
    updateNavbar () {
      const currentRoute = this.$router.currentRoute.name
      // Cronometro entra na lista porque é tela de projeção: só o número.
      this.showNavbar = !(currentRoute === 'SignIn' || currentRoute === 'SignUp' || currentRoute === 'Cronometro')
    }
  },
  components: {
    Navbar,
    Loading
  }
}
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css2?family=Raleway&display=swap')
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap')

html
  font-family: Lato, sans-serif
  padding: 0
  margin: 0
  min-height: 100vh

body
  padding: 0
  margin: 0

.main
  width: 100%

.main__content
  padding: 32px 8px 48px
  // Home: sem padding, p/ as seções full-bleed (hero, faixas, rodapé)
  // encostarem nas bordas. O conteúdo interno tem respiro próprio (.wrap).
  &--flush
    padding: 0
</style>
